import Input from "components/formInput/Input";
import "./styles.scss";
import Button from "components/button/Button";
import { useEffect, useState } from "react";

import { useHistory } from "react-router-dom";
import InputPassword from "components/formInput/InputPassword";
import { ROUTE } from "routes/route";
import i18n from "i18n";

import { apiValidateAccountClinic, apiSendMailResetPassword, apiResetPassword } from "helpers/api/accounts";
import { showToastError } from "utils";

const ResetPasswordStep = {
  inputRequest: "Step-1",
  confirmMail: "Setp-2",
  changePassword: "Setp-3",
  changdedSuccessfully: "Setp-4",
};

const ClinicResetPassword = (props) => {
  const searchParams = new URLSearchParams(window.location.search);
  const code = searchParams.get('code');
  const isExpired = searchParams.get('isExpired');
  const history = useHistory();

  useEffect(() => {
    if (isExpired) {
      showToastError("messages.MSG-USP086");
      window.history.replaceState({}, document.title, ROUTE.PUBLIC.RESET_PASSWORD);
      setStep(ResetPasswordStep.inputRequest);
    }
  }, [isExpired]);

  const [step, setStep] = useState(ResetPasswordStep.inputRequest);
  const [email, setEmail] = useState('');
  const [isValidEmail, setIsvalidEmail] = useState(true);
  const [newPassword, setNewPassword] = useState('');
  const [errorPassword, setErrorPassword] = useState('');
  const [newPasswordConfirm, setNewPasswordConfirm] = useState('');
  const [errorPasswordConfirm, setErrorPasswordConfirm] = useState('');

  useEffect(() => {
    if (code)
      setStep(ResetPasswordStep.changePassword);
  }, [code]);

  const handleChangeEmail = (event) => {
    const { value } = event.target;
    setEmail(value);
  }

  const onClickConfirmEmail = () => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (emailRegex.test(email)) {
      setIsvalidEmail(emailRegex.test(email));
      apiValidateAccountClinic(encodeURIComponent(email)).then((resp) => {
        if (resp.data.message) {
          sendMailResetPassword();
          setStep(ResetPasswordStep.confirmMail);
        }
      }).catch((err) => {
        showToastError("messages.MSG-USP016");
      });
    } else {
      setIsvalidEmail(false);
    }
  }

  const sendMailResetPassword = () => {
    apiSendMailResetPassword({ send_to: email }).then((resp) => {
      if (resp.data.message) {
        setStep(ResetPasswordStep.confirmMail);
      }
    }).catch((error) => {
      showToastError(error.data.error.message);
    });
  }

  const isValidPassword = (val) => {
    return val.length >= 8 && val.length <= 36;
  }

  const isMatchConfirmPassword = () => {
    return newPassword === newPasswordConfirm;
  }

  useEffect(() => {
    if (newPasswordConfirm !== '' && !isMatchConfirmPassword())
      setErrorPasswordConfirm(i18n.t("messages.MSG-USP011"));
    else
      setErrorPasswordConfirm('');
  }, [newPassword, newPasswordConfirm]);

  const handlerChangePassword = () => {
    if (!isValidPassword(newPassword)) {
      setErrorPassword(i18n.t("messages.MSG-USP003"));
      return;
    }
    else {
      setErrorPassword('');
    }

    if (!isMatchConfirmPassword())
      return;

    apiResetPassword({ code: code, new_password: newPassword }).then((resp) => {
      if (resp.data.message) {
        setStep(ResetPasswordStep.changdedSuccessfully)
      }
    }).catch((err) => {
      showToastError(i18n.t("messages.MSG-USP086"));
      window.history.replaceState({}, document.title, ROUTE.PUBLIC.RESET_PASSWORD);
      setStep(ResetPasswordStep.inputRequest);
    });
  }

  return (
    <div className="main-content">
      <div className="header-center">{step !== ResetPasswordStep.changdedSuccessfully ? 'パスワードの再設定' : 'パスワードの再設定完了'}</div>
      {step == ResetPasswordStep.inputRequest && (
        <div className="content">
          <div className="card-content">
            <Input
              // width={340}
              // style={{ width: 340 }}
              title={"登録メールアドレス"}
              placeholder={"xxxxx＠xxx.jp"}
              name="email"
              onChange={handleChangeEmail}
              type="email"
              error={!isValidEmail ? i18n.t("messages.MSG-USP001") : ''}
            />

            <Button
              className={'input-and-description btn-confirm-email'}
              style={{
                fontSize: 20,
                fontWeight: 900,
                borderRadius: 60,
                marginTop: 100,
              }}
              text={"次へ"}
              width={'100%'}
              height={40}
              disabled={!email}
              onClick={() => onClickConfirmEmail()}
            />
          </div>
        </div>
      )}

      {step == ResetPasswordStep.confirmMail && (
        <div className="content">
          <div className="card-content">
            <span className="content-text">
              <span>
                {email}
              </span>
              {"にパスワード再設定用メールを送信しました。"}
              <br />
              {
                "送信されたメール内のURLをクリックして、パスワード再設定を進めてください。"
              }
              <br />
            </span>

            <Button
              style={{
                fontSize: 20,
                fontWeight: 900,
                borderRadius: 60,
                marginTop: 150,
              }}
              text={"ログイン画面に戻る"}
              width={500}
              height={40}
              onClick={() => history.push(ROUTE.PUBLIC.LOGIN)}
            />
          </div>
        </div>
      )}

      {step == ResetPasswordStep.changePassword && (
        <div className="content">
          <div className="card-content">
            <InputPassword
              width={340}
              title={"新しいパスワード"}
              name="newPassword"
              onChange={(e) => setNewPassword(e.target.value)}
              error={errorPassword}
            />

            <InputPassword
              width={340}
              title={"新しいパスワード（確認用）"}
              name="newPasswordConfirm"
              onChange={(e) => setNewPasswordConfirm(e.target.value)}
              error={errorPasswordConfirm}
            />

            <Button
              style={{
                fontSize: 20,
                fontWeight: 900,
                borderRadius: 60,
                marginTop: 100,
              }}
              text={"再設定する"}
              width={500}
              height={40}
              onClick={() => handlerChangePassword()}
              disabled={!newPassword || !newPasswordConfirm}
            />
          </div>
        </div>
      )}

      {step == ResetPasswordStep.changdedSuccessfully && (
        <div className="content">
          <div className="card-content">
            <span className="content-text">
              {"パスワードを再設定しました。"}
              <br />
              {"ログイン画面に戻りログインして下さい。"}
              <br />
            </span>

            <Button
              style={{
                fontSize: 20,
                fontWeight: 900,
                borderRadius: 60,
                marginTop: 150,
              }}
              text={"ログイン"}
              width={500}
              height={40}
              onClick={() => {
                history.push(ROUTE.PUBLIC.LOGIN);
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default ClinicResetPassword;
